const MAP_METHODS_SELECTOR_TRACKING = {
  ACCOUNT_CHECK: 'yourBank',
  BIZUM: 'bizum',
  VIDEOCALL: 'videoSelfie',
};

const MAP_METHODS_MODAL_TRACKING = {
  ACCOUNT_CHECK: 'Openbanking',
  BIZUM: 'Bizum',
  VIDEOCALL: 'VideoSelfie',
};

export { MAP_METHODS_MODAL_TRACKING, MAP_METHODS_SELECTOR_TRACKING };
